// extracted by mini-css-extract-plugin
module.exports = {"root":"FullWidthCta_root__Fgve7","wrapper":"FullWidthCta_wrapper__bxbVe","title":"FullWidthCta_title__ZWIew","ctaButton":"FullWidthCta_ctaButton__vZ4RK"};